import { Box, Typography } from '@mui/material';
import { pxToRem } from '@geneo2-web/shared-ui';
import { BloomStats } from '../performanceDrawerData';
import { BloomProgressItem } from '../../BloomProgressItem';

interface BloomSectionProps {
  data?: BloomStats[];
}
const drawerStyles = {
  card: {
    backgroundColor: '#fff',
    // boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
};

export const BloomSection = ({ data }: BloomSectionProps) => {
  if (!data || data.length === 0) return null;

  return (
    <Box sx={drawerStyles.card}>
      {/* HEADER */}
      <Box sx={drawerStyles.cardHeader}>
        <Typography fontSize={pxToRem(18)}>🧠</Typography>
        <Typography
          variant="cardText"
          sx={{
            fontFamily: 'Poppins',
            color: '#1e293b',
          }}
        >
          Bloom's Taxonomy
        </Typography>
      </Box>

      {/* LIST */}
      <Box
        display="flex"
        flexDirection="column"
        gap={pxToRem(10)}
        mt={pxToRem(14)}
      >
        <BloomProgressItem data={data} />
      </Box>
    </Box>
  );
};
